// import plusIcon from "../assets/svg/plus-table.svg";
import {apiGetJournals} from "api/reportApi";
import {PriceComponent} from "components/Table/CellComponents";
import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "../helpers/DrawerActions";

const journalColumns = [
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "حساب",
        key: "account",
        filterParams: {
            column: "account",
            columnType: "string",
        },
        clickable: (item: any) => true,
        onClick: (dispatch: any, item: any) => {
            openAccountingDrawer(dispatch, item);
        },
    },
    {
        name: "کد حساب",
        key: "code",
        filterParams: {
            column: "code",
            columnType: "string",
        },
        clickable: (item: any) => true,
        onClick: (dispatch: any, item: any) => {
            openAccountingDrawer(dispatch, item);
        },
    },
    {
        name: "تفصیل",
        key: "detail",
        filterParams: {
            column: "detail",
            columnType: "string",
        },
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        clickable: (item: any) => item && item.type && item.type_id,
        onClick: (dispatch: any, item: any) => {
            if (item.type && item.type_id) {
                if (item.type === "factor") {
                    openFactorDrawer(dispatch, item);
                } else if (item.type === "transaction") {
                    openTransactionDrawer(dispatch, item);
                } else if (item.type === "transfer") {
                    openTransferDrawer(dispatch, item);
                } else if (item.type === "bill") {
                    openRemittanceDrawer(dispatch, item);
                }
            }
        },
    },
    {
        name: "بدهکار",
        key: "debtor",
        price: true,
        // @ts-ignore
        getValue: (item) => {
            return !item.isCreditor ? item.amount : "-";
        },
        Component: PriceComponent,
        filterParams: {
            column: "debtor",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "بستانکار",
        key: "creditor",
        price: true,
        // @ts-ignore
        getValue: (item) => {
            return item.isCreditor ? item.amount : "-";
        },
        Component: PriceComponent,
        filterParams: {
            column: "creditor",
            columnType: "number",
        },
        searchType: "quantitative",
    },
];

export const journalIndexData = [
    {
        key: "journal",
        label: "دفتر روزنامه",
        pluralLabel: "دفتر روزنامه",
        title: "دفتر روزنامه",
        pageTitle: "دفتر روزنامه",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: journalColumns,
        disableSearch: true,
        actions: {
            back: {},
            fetch: apiGetJournals,
            // excel: {},
        },
    },
];
